import "./src/styles/global.css"

import Modal from "react-modal";

export const onInitialClientRender = () => {
  Modal.setAppElement('#___gatsby');
};